import { useState } from 'react'
import { useFireStore, useStorage } from '../../firebase/firebase'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'context/AuthContext'

export default function Onboarding() {

    const history = useHistory()
    const { currentUser } = useAuth()
    const [username, setUsername] = useState()
    const [file, setFile] = useState(null)

    const uploadMe = (e) => {

        const collectionRef = useFireStore.collection('users').doc(`${currentUser.uid}`);
        const storageRef = useStorage.ref()
        const fileRef = storageRef.child('profilePhotos/'+file.name)

        // three lines to upload the photo and text
        fileRef.put(file).then(() => {
            fileRef.getDownloadURL().then(function (url) {
                collectionRef.set({
                    username: username,
                    profilePhotoUrl: url,
                    gid: currentUser.uid,
                    emailVerified: false
                })
            });
        })
        setUsername('');
        setFile(null);
        console.log('user Added and that')
        history.push("/")
    }

    return (
        <div className="p-8 border rounded-lg w-190 border-borderlight">
            <h2>welcome</h2>
            <form>
                <div>
                    <label class="text-gray-700 dark:text-gray-200" for="pic">Profile picture</label>
                    <input id="pic" type="file" onChange={(e) => setFile(e.target.files[0])} class="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"/>
                </div>
                <div>
                    <label class="text-gray-700 dark:text-gray-200" for="username">Username</label>
                    <input id="username" type="text" onChange={(e) => setUsername(e.target.value)} class="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"/>
                </div>
                <button onClick={uploadMe}>submit</button>
            </form>
        </div>
    )
}
